module.exports = [
  {
    title: 'Компьютерная диагностика',
    info:
      'Ремонт автомобиля должен начинаться с компьютерной диагностики. Она позволяет с большой долей точности определить несиправность.',
    items: [
      {
        title: 'Компьютерная диагностика Bosch',
        info:
          'Во многих автомобилях установлена топливная техника Bosch. Это один из лидеров по производству топливной аппаратуры для дизельных двигателей. Наш сервис предоставляет компьютерную диагностику такой техники с помощью Bosch KTS. Это позволяет детально изучить такие параметры:',
        list: [
          'считывание/стирание кодов неисправностей',
          'вывод текущих параметры системы в цифровом/графическом виде',
          'активирует специальные режимы работы контроллера',
          'описывает расположение диагностических колодок',
          'сбрасывает сервисные счетчики',
          'контролирует уровень масла',
          'разблокирует иммобилайзер',
          'проверка ESP',
          'другие функции (чтение VIN, статический тест и т.д.)'
        ]
      },
      {
        title: 'Компьютерная диагностика Delphi',
        info:
          'Также одним из лидеров топливной дизельной аппаратуры является Delphi. Для этого оборудования в нашем сервисе имеется официальная диагностика Delphi. Кроме всего прочего диагностический прибор Delphi позволяет проводить диагностику:',
        list: [
          'двигателя по заводским протоколам',
          'систем управления климатом',
          'иммобилайзеров',
          'систем управления трансмиссией',
          'систем ABS',
          'систем SRS Airbag',
          'систем обеспечения комфорта',
          'систем кузовной электроникиа'
        ]
      },
      {
        title: 'Компьютерная диагностика OEM',
        info:
          'Кроме таких мульти-сканеров которые предлагает Bosch и Delphi, в нашем распоряжении есть оригинальная диагностика от производителей авто. Она позволяет провести полную диагностику авто конкретной марки. В отдельных случаях позволяет считать те параметры, которые не могут считать мульти-марочные сканеры.',
        list: [
          'компьютерная диагностика Mercedes-Benz',
          'компьютерная диагностика VW',
          'компьютерная диагностика Volvo',
          'компьютерная диагностика Scania',
          'OEM компьютерная диагностика двигателей Cummins, Detroit Diesel, Caterpillar'
        ]
      },
      {
        title: 'Выездная диагностика',
        info:
          'Возможна выездная диагностика. Должны заметить, что диагностика это лишь часть ремонта, в которой определяется причина неисправности. В некоторых отдельных случаях не представляется возможным провести диагностику на месте. Иногда нужно провести частичную разборку, загнать машину на яму, провести диагностику дополнительным оборудованием (осцилографом, нанометром). В большинстве случаев мы советуем Вам транспортировать технику в наш сервис и на месте решать проблему.'
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/data/comp.js